const initializeConversationMute = () => {
    const form = document.querySelector(
        '[data-conversation-mute]'
    );

    if (!form) {
        return;
    }

    const button = form.querySelector(
        '[data-conversation-mute-button]'
    );

    if (!button) {
        return;
    }

    let submitting = false;

    const setSubmitting = (isSubmitting) => {
        submitting = isSubmitting;
        button.disabled = isSubmitting;

        button.classList.toggle(
            'opacity-60',
            isSubmitting
        );

        button.classList.toggle(
            'cursor-not-allowed',
            isSubmitting
        );

        if (isSubmitting) {
            button.textContent = 'Updating...';
        }
    };

    const updateButton = (isMuted) => {
        button.textContent = isMuted
            ? 'Unmute Notifications'
            : 'Mute Notifications';

        button.classList.toggle(
            'border-cyan-400/30',
            isMuted
        );

        button.classList.toggle(
            'bg-cyan-400/10',
            isMuted
        );

        button.classList.toggle(
            'text-cyan-200',
            isMuted
        );

        button.classList.toggle(
            'border-amber-400/30',
            !isMuted
        );

        button.classList.toggle(
            'bg-amber-400/10',
            !isMuted
        );

        button.classList.toggle(
            'text-amber-200',
            !isMuted
        );
    };

    form.addEventListener(
        'submit',
        async (event) => {
            event.preventDefault();

            if (submitting) {
                return;
            }

            setSubmitting(true);

            try {
                const response = await fetch(
                    form.action,
                    {
                        method: form.method.toUpperCase(),
                        body: new FormData(form),
                        credentials: 'same-origin',
                        headers: {
                            Accept: 'application/json',
                            'X-Requested-With':
                                'XMLHttpRequest',
                        },
                    }
                );

                const data = await response.json()
                    .catch(() => ({}));

                if (!response.ok) {
                    throw new Error(
                        data.message
                        || 'The notification setting could not be updated.'
                    );
                }

                updateButton(Boolean(data.muted));
            } catch (error) {
                alert(
                    error instanceof Error
                        ? error.message
                        : 'The notification setting could not be updated.'
                );

                window.location.reload();
            } finally {
                setSubmitting(false);
            }
        }
    );
};

if (
    document.readyState === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeConversationMute
    );
} else {
    initializeConversationMute();
}